export { default as DefaultPage } from './DefaultPage';
export { default as SystemConfigTypePage } from './SystemConfigTypePage';
export { default as SystemConfigPage } from './SystemConfigPage';
export { default as Test } from './Test';



// WEBPACK FOOTER //
// ./src/features/systemconfig/index.js